"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FilterOperator = {
  AND: 'and',
  OR: 'or'
};
var _default = FilterOperator;
exports.default = _default;
